import { Divider, Stack } from "@mui/material"
import type { FormTab } from "@pharmupp/p3-front-commons"
import { Contact } from "./Contact/Contact"
import { type ContactFormValues, contactSchema } from "./Contact/Contact.schema"
import { Digital } from "./Digital/Digital"
import { type DigitalFormValues, digitalSchema } from "./Digital/Digital.schema"
import { Holder } from "./Holder/Holder"
import { Location } from "./Location/Location"
import { type LocationFormValues, locationSchema } from "./Location/Location.schema"
import { MyPharmacy } from "./MyPharmacy/MyPharmacy"
import {
  type MyPharmacyFormValues,
  myPharmacySchema,
} from "./MyPharmacy/MyPharmacy.schema"

import { detailsSchema as generalInfosSchema } from "./details.schema"
import type { GeneralInfosPostForm } from "./useGeneralInfosApi"

const holdersSchema = generalInfosSchema.pick(["primaryHolder", "otherHolders"])

export const detailsSchema = myPharmacySchema
  .concat(locationSchema)
  .concat(contactSchema)
  .concat(digitalSchema)
  .concat(holdersSchema)

type HolderFormValues = Pick<GeneralInfosPostForm, "primaryHolder" | "otherHolders">
// Combine all form types to preserve custom types (like DigitalFormValues.socialMediaUrls)
export type DetailsFormValues = MyPharmacyFormValues &
  LocationFormValues &
  ContactFormValues &
  DigitalFormValues &
  HolderFormValues

const DetailsTabContent = () => (
  <Stack divider={<Divider flexItem />}>
    <MyPharmacy />
    <Location />
    <Contact />
    <Digital />
    <Holder />
  </Stack>
)

export const detailsTabs: FormTab[] = [
  {
    label: "Coordonnées",
    to: ".",
    Element: DetailsTabContent,
    schema: detailsSchema,
  },
]
